"use client";

import { useEffect, useState } from "react";
import { captureWebsiteException } from "@/lib/websiteErrors";
import { isLocale, localeInfo } from "@/lib/i18n/locales";
import english from "@/messages/en/common.json";

/** Next.js renders this outside all root layouts when a layout or server-rendered page fails. */
export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const [copy, setCopy] = useState({ message: english.error_boundary, retry: english.try_again, locale: "en", dir: "ltr" as "ltr" | "rtl" });
  useEffect(() => {
    captureWebsiteException(error, { reason: "next_boundary" });
    const parts = window.location.pathname.split("/").filter(Boolean);
    if (parts[0] === "embed") parts.shift();
    const locale = isLocale(parts[0]) ? parts[0] : "en";
    void import(`../messages/${locale}/common.json`).then(messages => {
      setCopy({ message: messages.error_boundary, retry: messages.try_again, locale, dir: localeInfo(locale).dir });
    }).catch(cause => captureWebsiteException(cause, { reason: "error_translation" }));
  }, [error]);
  return <html lang={copy.locale} dir={copy.dir}><body>
    <div role="alert" style={{ margin: "4rem auto", maxWidth: "36rem", padding: "2rem", textAlign: "center", fontFamily: "system-ui, sans-serif" }}>
      <p>{copy.message}</p><button type="button" onClick={reset}>{copy.retry}</button>
    </div>
  </body></html>;
}
